"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhanceWithValidation = enhanceWithValidation;
exports.default = exports.emailValidation = exports.specialCharactersValidation = exports.wrappedFieldRendererValidation = exports.linkFieldValidation = exports.recurrenceValidation = exports.childComponentValidation = exports.geoLocationRequireValidation = exports.allowedExtensionsValidation = exports.referenceMinItems = exports.referenceMaxItems = exports.rejectedFilesValidation = exports.maxSizeValidation = exports.minSizeValidation = exports.mustBeImageValidation = exports.imageAspectRatioValidation = exports.imageMaxHeightValidation = exports.imageMinHeightValidation = exports.imageMaxWidthValidation = exports.imageMinWidthValidation = exports.dateRangeBoundryValidation = exports.dateRangeValidDateValidation = exports.dateRangeMaxValueValidation = exports.dateRangeMinValueValidation = exports.numberRangeBoundryValidation = exports.rangeRequiredValidation = exports.numberRangeMaxValue = exports.numberRangeMinValue = exports.maxValueDateValidation = exports.minValueDateValidation = exports.validDateValidation = exports.maxValueValidation = exports.minValueValidation = exports.maxLengthValidation = exports.minLengthValidation = exports.regExpValidation = exports.isRegExpValidation = exports.requiredArrayValidation = exports.requiredValidation = exports.errorMessage = exports.validationNames = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));

var _react = _interopRequireDefault(require("react"));

var _recurrenceTypes = require("../DateTimeRange/recurrenceTypes");

var _DateHelper = require("../Utilities/DateHelper");

var _StringHelper = require("../Utilities/StringHelper");

var _Validations = _interopRequireDefault(require("./Validations"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e) { function e(_x68) { return _e.apply(this, arguments); } e.toString = function () { return _e.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e2) { function e(_x69) { return _e2.apply(this, arguments); } e.toString = function () { return _e2.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var prefix = {
  from: "from",
  to: "to"
};

var shouldValidateImagePixelDimensions = function shouldValidateImagePixelDimensions(file) {
  var shouldValidate = false;

  if (file.isImage && file.fileExtension !== "svg") {
    shouldValidate = true;
  }

  return shouldValidate;
};

var getImage = function getImage(file) {
  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function () {
      return resolve({
        width: img.naturalWidth || img.width,
        height: img.naturalHeight || img.height
      });
    };

    img.onerror = reject;
    img.src = file.preview;
  });
};

var validationNames = {
  required: "required",
  requiredArray: "requiredArray",
  regExpPattern: "regExpPattern",
  minLength: "minLength",
  maxLength: "maxLength",
  minValue: "minValue",
  maxValue: "maxValue",
  validDateFormat: "validDateFormat",
  minValueDateValidation: "minValueDateValidation",
  maxValueDateValidation: "maxValueDateValidation",
  rangeRequired: "RangeRequired",
  fromRangeRequired: "".concat(prefix.from, "RangeRequired"),
  toRangeRequired: "".concat(prefix.to, "RangeRequired"),
  numberRangeMinValue: "numberRangeMinValue",
  fromNumberRangeMinValue: "".concat(prefix.from, "NumberRangeMinValue"),
  toNumberRangeMinValue: "".concat(prefix.to, "NumberRangeMinValue"),
  numberRangeMaxValue: "numberRangeMaxValue",
  fromNumberRangeMaxValue: "".concat(prefix.from, "NumberRangeMaxValue"),
  toNumberRangeMaxValue: "".concat(prefix.to, "NumberRangeMaxValue"),
  numberRangeBoundry: "numberRangeBoundry",
  datesValidRangeValidation: "datesValidRangeValidation",
  fromValidDateRangeValidation: "".concat(prefix.from, "validDateRangeValidation"),
  toValidDateRangeValidation: "".concat(prefix.to, "validDateRangeValidation"),
  dateRangeBoundry: "dateRangeBoundry",
  dateRangeMinValueValidation: "dateRangeMinValueValidation",
  fromDateRangeMinValueValidation: "".concat(prefix.from, "DateRangeMinValueValidation"),
  toDateRangeMinValueValidation: "".concat(prefix.to, "DateRangeMinValueValidation"),
  dateRangeMaxValueValidation: "dateRangeMaxValueValidation",
  fromDateRangeMaxValueValidation: "".concat(prefix.from, "DateRangeMaxValueValidation"),
  toDateRangeMaxValueValidation: "".concat(prefix.to, "DateRangeMaxValueValidation"),
  imageMaxHeightValidation: "imageMaxHeightValidation",
  imageMinHeightValidation: "imageMinHeightValidation",
  imageMaxWidthValidation: "imageMaxWidthValidation",
  imageMinWidthValidation: "imageMinWidthValidation",
  maxSizeValidation: "maxSizeValidation",
  minSizeValidation: "minSizeValidation",
  imageAspectRatioValidation: "imageAspectRatioValidation",
  mustBeImageValidation: "mustBeImageValidation",
  rejectedFilesValidation: "rejectedFilesValidation",
  referenceMaxItems: "referenceMaxItems",
  referenceMinItems: "referenceMinItems",
  allowedExtensionsValidation: "allowedExtensionsValidation",
  childComponentValidation: "childComponentValidation",
  wrappedFieldRendererValidation: "wrappedFieldRendererValidation",
  emailValidation: "emailValidation",
  specialCharactersValidation: "specialCharactersValidation",
  isRegExpValidation: "isRegExpValidation"
}; // Using `any` because I don't want to break existing consuming code. Also including the type it should be.

exports.validationNames = validationNames;

var errorMessage = function errorMessage(validation, errorMessages, defaultMessage) {
  var customMessage = errorMessages ? errorMessages[validation] : undefined;
  return customMessage || defaultMessage;
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.errorMessage = errorMessage;

var requiredValidation = function requiredValidation(value, props, component) {
  var result = {
    error: !value,
    message: errorMessage(validationNames.required, props.errorMessages, "This field cannot be blank."),
    validationName: validationNames.required
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.requiredValidation = requiredValidation;

var requiredArrayValidation = function requiredArrayValidation(value, props, component) {
  var result = {
    error: value === undefined || value === null || value.length === 0,
    message: errorMessage(validationNames.requiredArray, props.errorMessages, "This field cannot be blank."),
    validationName: validationNames.requiredArray
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.requiredArrayValidation = requiredArrayValidation;

var isRegExpValidation = function isRegExpValidation(value, props, component) {
  var isRegex = true;

  try {
    new RegExp(value);
  } catch (e) {
    isRegex = false;
  }

  var result = {
    error: !isRegex,
    message: errorMessage(validationNames.isRegExpValidation, props.errorMessage, "This field must be a valid regular expression."),
    validationName: validationNames.isRegExpValidation
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.isRegExpValidation = isRegExpValidation;

var regExpValidation = function regExpValidation(value, props, component) {
  var regExpPattern = props.regExpPattern;
  var result = {
    error: value && !(0, _StringHelper.isNullOrWhiteSpace)(regExpPattern) ? !RegExp(regExpPattern).test(value) : false,
    message: errorMessage(validationNames.regExpPattern, props.errorMessages, "This field did not match the regular expression provided."),
    validationName: validationNames.regExpPattern
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.regExpValidation = regExpValidation;

var minLengthValidation = function minLengthValidation(value, props, component) {
  var minLength = props.minLength;
  var result = {
    error: value && minLength > value.length,
    message: errorMessage(validationNames.minLength, props.errorMessages, "The minimum length allowed is ".concat(minLength, ".")),
    validationName: validationNames.minLength
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.minLengthValidation = minLengthValidation;

var maxLengthValidation = function maxLengthValidation(value, props, component) {
  var _ref;

  var maxLength = props.maxLength;
  var result = {
    error: (_ref = maxLength < (value === null || value === void 0 ? void 0 : value.length)) !== null && _ref !== void 0 ? _ref : 0,
    message: errorMessage(validationNames.maxLength, props.errorMessages, "The maximum length allowed is ".concat(maxLength, ".")),
    validationName: validationNames.maxLength
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.maxLengthValidation = maxLengthValidation;

var minValueValidation = function minValueValidation(value, props, component) {
  var minValue = props.minValue;
  var result = {
    error: value ? minValue > value : false,
    message: errorMessage(validationNames.minValue, props.errorMessages, "A minimum value of ".concat(minValue, " is required.")),
    validationName: validationNames.minValue
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.minValueValidation = minValueValidation;

var maxValueValidation = function maxValueValidation(value, props, component) {
  var maxValue = props.maxValue;
  var result = {
    error: value ? maxValue < value : false,
    message: errorMessage(validationNames.maxValue, props.errorMessages, "The maximum value allowed is ".concat(maxValue, ".")),
    validationName: validationNames.maxValue
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.maxValueValidation = maxValueValidation;

var validDateValidation = function validDateValidation(value, props, component) {
  if (value) {
    var parsedDate = Date.parse(value);
    var timeUnit = props && props.pickerType === "time" ? "time" : "date";
    var result = {
      error: isNaN(parsedDate),
      message: errorMessage(validationNames.validDateFormat, props.errorMessages, "Please enter a valid ".concat(timeUnit, ".")),
      validationName: validationNames.validDateFormat
    };
    return result.error ? Promise.reject(result) : Promise.resolve(result);
  }

  return Promise.resolve({
    error: false,
    message: undefined,
    validationName: validationNames.validDateFormat
  });
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.validDateValidation = validDateValidation;

var minValueDateValidation = function minValueDateValidation(value, props, component) {
  var _component$props = component.props,
      minValue = _component$props.minValue,
      format = _component$props.format;
  var parsedDate = Date.parse(value);
  var parsedMinValue = Date.parse(minValue);
  var result = {
    error: Boolean(parsedMinValue) && parsedDate < parsedMinValue,
    message: errorMessage(validationNames.minValueDateValidation, props.errorMessages, "Date must be after, ".concat((0, _DateHelper.formatDate)(minValue, format))),
    validationName: validationNames.minValueDateValidation
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.minValueDateValidation = minValueDateValidation;

var maxValueDateValidation = function maxValueDateValidation(value, props, component) {
  var _component$props2 = component.props,
      maxValue = _component$props2.maxValue,
      format = _component$props2.format;
  var parsedDate = Date.parse(value);
  var parsedMaxValue = Date.parse(maxValue);
  var result = {
    error: Boolean(parsedMaxValue) && parsedDate > parsedMaxValue,
    message: errorMessage(validationNames.maxValueDateValidation, props.errorMessages, "Date must be before, ".concat((0, _DateHelper.formatDate)(maxValue, format))),
    validationName: validationNames.maxValueDateValidation
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */
// TODO: There's no return for the else case, so we're returning undefined in that case. Seems better to return a ValidationResult type of object there.


exports.maxValueDateValidation = maxValueDateValidation;

var numberRangeMinValue = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value, props, component) {
    var _getValue, from, to, errorMessages, fromProps, toProps, fromResult, toResult;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getValue = getValue(props, component), from = _getValue.from, to = _getValue.to;
            errorMessages = props.errorMessages, fromProps = props.fromProps, toProps = props.toProps;
            _context.next = 4;
            return minValueValidation(from, props, component).catch(function (result) {
              return result;
            });

          case 4:
            fromResult = _context.sent;
            _context.next = 7;
            return minValueValidation(to, props, component).catch(function (result) {
              return result;
            });

          case 7:
            toResult = _context.sent;

            if (!(fromResult.error && toResult.error)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.numberRangeMinValue, errorMessages, "This field are less than the minimum value allowed."),
              messageTo: errorMessage(validationNames.numberRangeMinValue, errorMessages, "This field are less than the minimum value allowed."),
              validationName: validationNames.numberRangeMinValue
            }));

          case 12:
            if (!fromResult.error) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.fromNumberRangeMinValue, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " is less than the minimum value of ").concat(props.minValue, ".")),
              validationName: validationNames.fromNumberRangeMinValue
            }));

          case 16:
            if (!toResult.error) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              error: true,
              messageTo: errorMessage(validationNames.toNumberRangeMinValue, errorMessages, "".concat(toProps && toProps.label ? toProps.label : "To field", " is less than the minimum value of ").concat(props.minValue, ".")),
              validationName: validationNames.toNumberRangeMinValue
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function numberRangeMinValue(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */
// TODO: There's no return for the else case, so we're returning undefined in that case. Seems better to return a ValidationResult type of object there.


exports.numberRangeMinValue = numberRangeMinValue;

var numberRangeMaxValue = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value, props, component) {
    var _getValue2, from, to, errorMessages, fromProps, toProps, fromResult, toResult;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getValue2 = getValue(props, component), from = _getValue2.from, to = _getValue2.to;
            errorMessages = props.errorMessages, fromProps = props.fromProps, toProps = props.toProps;
            _context2.next = 4;
            return maxValueValidation(from, props, component).catch(function (result) {
              return result;
            });

          case 4:
            fromResult = _context2.sent;
            _context2.next = 7;
            return maxValueValidation(to, props, component).catch(function (result) {
              return result;
            });

          case 7:
            toResult = _context2.sent;

            if (!(fromResult.error && toResult.error)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.numberRangeMaxValue, errorMessages, "This field are greater than the maximum value allowed."),
              messageTo: errorMessage(validationNames.numberRangeMaxValue, errorMessages, "This field are greater than the maximum value allowed."),
              validationName: validationNames.numberRangeMaxValue
            }));

          case 12:
            if (!fromResult.error) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.fromNumberRangeMaxValue, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " is greater than the maximum value of ").concat(props.maxValue, ".")),
              validationName: validationNames.fromNumberRangeMaxValue
            }));

          case 16:
            if (!toResult.error) {
              _context2.next = 18;
              break;
            }

            return _context2.abrupt("return", Promise.reject({
              error: true,
              messageTo: errorMessage(validationNames.toNumberRangeMaxValue, errorMessages, "".concat(toProps && toProps.label ? toProps.label : "To field", " is greater than the maximum value of ").concat(props.maxValue, ".")),
              validationName: validationNames.toNumberRangeMaxValue
            }));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function numberRangeMaxValue(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.numberRangeMaxValue = numberRangeMaxValue;

var rangeRequiredValidation = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(value, props, component) {
    var _getValue3, from, to, errorMessages, fromProps, toProps, required, fromResult, toResult;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getValue3 = getValue(props, component), from = _getValue3.from, to = _getValue3.to;
            errorMessages = props.errorMessages, fromProps = props.fromProps, toProps = props.toProps, required = props.required;

            if (!(!required && !from && !to)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", Promise.resolve({
              error: false,
              messagesFrom: "",
              messagesTo: "",
              validationName: validationNames.rangeRequired
            }));

          case 4:
            _context3.next = 6;
            return requiredValidation(from, props, component).catch(function (result) {
              return result;
            });

          case 6:
            fromResult = _context3.sent;
            _context3.next = 9;
            return requiredValidation(to, props, component).catch(function (result) {
              return result;
            });

          case 9:
            toResult = _context3.sent;

            if (!(fromResult.error && toResult.error)) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.rangeRequired, errorMessages, "This field cannot be blank."),
              messageTo: errorMessage(validationNames.rangeRequired, errorMessages, "This field cannot be blank."),
              validationName: validationNames.rangeRequired
            }));

          case 14:
            if (!fromResult.error) {
              _context3.next = 18;
              break;
            }

            return _context3.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.fromRangeRequired, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " cannot be blank.")),
              validationName: validationNames.fromRangeRequired
            }));

          case 18:
            if (!toResult.error) {
              _context3.next = 22;
              break;
            }

            return _context3.abrupt("return", Promise.reject({
              error: true,
              messageTo: errorMessage(validationNames.toRangeRequired, errorMessages, "".concat(toProps && toProps.label ? toProps.label : "To field", " cannot be blank.")),
              validationName: validationNames.toRangeRequired
            }));

          case 22:
            return _context3.abrupt("return", Promise.resolve({
              error: false,
              messageFrom: "",
              messageTo: "",
              validationName: validationNames.rangeRequired
            }));

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function rangeRequiredValidation(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.rangeRequiredValidation = rangeRequiredValidation;

var numberRangeBoundryValidation = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(value, props, component) {
    var _getValue4, from, to, errorMessages, fromProps, toProps;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _getValue4 = getValue(props, component), from = _getValue4.from, to = _getValue4.to;
            errorMessages = props.errorMessages, fromProps = props.fromProps, toProps = props.toProps;

            if (!(from && to && Number(from) > Number(to))) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.numberRangeBoundry, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " cannot be greater than ").concat(toProps && toProps.label ? toProps.label : "To field", ".")),
              validationName: validationNames.numberRangeBoundry
            }));

          case 6:
            return _context4.abrupt("return", Promise.resolve({
              error: false,
              messageFrom: "",
              messageTo: "",
              validationName: validationNames.numberRangeBoundry
            }));

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function numberRangeBoundryValidation(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.numberRangeBoundryValidation = numberRangeBoundryValidation;

var dateRangeMinValueValidation = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(value, props, component) {
    var _getValue5, from, to, _component$props3, errorMessages, fromProps, toProps, minValue, format, fromResult, toResult, formattedMinValue;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _getValue5 = getValue(props, component), from = _getValue5.from, to = _getValue5.to;
            _component$props3 = component.props, errorMessages = _component$props3.errorMessages, fromProps = _component$props3.fromProps, toProps = _component$props3.toProps, minValue = _component$props3.minValue, format = _component$props3.format;
            _context5.next = 4;
            return minValueDateValidation(from, props, component).catch(function (result) {
              return result;
            });

          case 4:
            fromResult = _context5.sent;
            _context5.next = 7;
            return minValueDateValidation(to, props, component).catch(function (result) {
              return result;
            });

          case 7:
            toResult = _context5.sent;
            formattedMinValue = (0, _DateHelper.formatDate)(minValue, format);

            if (!(fromResult.error && toResult.error)) {
              _context5.next = 13;
              break;
            }

            return _context5.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.dateRangeMinValueValidation, errorMessages, "Fields cannot be before ".concat(formattedMinValue)),
              messageTo: errorMessage(validationNames.dateRangeMinValueValidation, errorMessages, "Fields cannot be before ".concat(formattedMinValue)),
              validationName: validationNames.dateRangeMinValueValidation
            }));

          case 13:
            if (!fromResult.error) {
              _context5.next = 17;
              break;
            }

            return _context5.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.fromDateRangeMinValueValidation, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " cannot be before ").concat(formattedMinValue, ".")),
              validationName: validationNames.fromDateRangeMinValueValidation
            }));

          case 17:
            if (!toResult.error) {
              _context5.next = 21;
              break;
            }

            return _context5.abrupt("return", Promise.reject({
              error: true,
              messageTo: errorMessage(validationNames.toDateRangeMinValueValidation, errorMessages, "".concat(toProps && toProps.label ? toProps.label : "To field", " cannot be before ").concat(formattedMinValue, ".")),
              validationName: validationNames.fromDateRangeMinValueValidation
            }));

          case 21:
            return _context5.abrupt("return", Promise.resolve({
              error: false,
              messageFrom: "",
              messageTo: "",
              validationName: validationNames.dateRangeMinValueValidation
            }));

          case 22:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function dateRangeMinValueValidation(_x13, _x14, _x15) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.dateRangeMinValueValidation = dateRangeMinValueValidation;

var dateRangeMaxValueValidation = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(value, props, component) {
    var _getValue6, from, to, _component$props4, errorMessages, fromProps, toProps, maxValue, format, fromResult, toResult, formattedMaxDate;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _getValue6 = getValue(props, component), from = _getValue6.from, to = _getValue6.to;
            _component$props4 = component.props, errorMessages = _component$props4.errorMessages, fromProps = _component$props4.fromProps, toProps = _component$props4.toProps, maxValue = _component$props4.maxValue, format = _component$props4.format;
            _context6.next = 4;
            return maxValueDateValidation(from, props, component).catch(function (result) {
              return result;
            });

          case 4:
            fromResult = _context6.sent;
            _context6.next = 7;
            return maxValueDateValidation(to, props, component).catch(function (result) {
              return result;
            });

          case 7:
            toResult = _context6.sent;
            formattedMaxDate = (0, _DateHelper.formatDate)(maxValue, format);

            if (!(fromResult.error && toResult.error)) {
              _context6.next = 13;
              break;
            }

            return _context6.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.dateRangeMaxValueValidation, errorMessages, "Fields cannot be after ".concat(formattedMaxDate)),
              messageTo: errorMessage(validationNames.dateRangeMaxValueValidation, errorMessages, "Fields cannot be after ".concat(formattedMaxDate)),
              validationName: validationNames.dateRangeMaxValueValidation
            }));

          case 13:
            if (!fromResult.error) {
              _context6.next = 17;
              break;
            }

            return _context6.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.fromDateRangeMaxValueValidation, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " cannot be after ").concat(formattedMaxDate, ".")),
              validationName: validationNames.fromDateRangeMaxValueValidation
            }));

          case 17:
            if (!toResult.error) {
              _context6.next = 21;
              break;
            }

            return _context6.abrupt("return", Promise.reject({
              error: true,
              messageTo: errorMessage(validationNames.toDateRangeMaxValueValidation, errorMessages, "".concat(toProps && toProps.label ? toProps.label : "To field", " cannot be after ").concat(formattedMaxDate, ".")),
              validationName: validationNames.toDateRangeMaxValueValidation
            }));

          case 21:
            return _context6.abrupt("return", Promise.resolve({
              error: false,
              messageFrom: "",
              messageTo: "",
              validationName: validationNames.dateRangeMaxValueValidation
            }));

          case 22:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function dateRangeMaxValueValidation(_x16, _x17, _x18) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.dateRangeMaxValueValidation = dateRangeMaxValueValidation;

var dateRangeValidDateValidation = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(value, props, component) {
    var _getValue7, from, to, errorMessages, fromProps, toProps, fromResult, toResult;

    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _getValue7 = getValue(props, component), from = _getValue7.from, to = _getValue7.to;
            errorMessages = props.errorMessages, fromProps = props.fromProps, toProps = props.toProps;
            _context7.next = 4;
            return validDateValidation(from, props, component).catch(function (result) {
              return result;
            });

          case 4:
            fromResult = _context7.sent;
            _context7.next = 7;
            return validDateValidation(to, props, component).catch(function (result) {
              return result;
            });

          case 7:
            toResult = _context7.sent;

            if (!(fromResult.error && toResult.error)) {
              _context7.next = 12;
              break;
            }

            return _context7.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.datesValidRangeValidation, errorMessages, "This field require a valid date format."),
              messageTo: errorMessage(validationNames.datesValidRangeValidation, errorMessages, "This field require a valid date format."),
              validationName: validationNames.datesValidRangeValidation
            }));

          case 12:
            if (!fromResult.error) {
              _context7.next = 16;
              break;
            }

            return _context7.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.fromValidDateRangeValidation, errorMessages, "".concat(fromProps && fromProps.label ? fromProps.label : "From field", " requires a valid date format.")),
              validationName: validationNames.fromValidDateRangeValidation
            }));

          case 16:
            if (!toResult.error) {
              _context7.next = 20;
              break;
            }

            return _context7.abrupt("return", Promise.reject({
              error: true,
              messageTo: errorMessage(validationNames.toValidDateRangeValidation, errorMessages, "".concat(toProps && toProps.label ? toProps.label : "To field", " requires a valid date format.")),
              validationName: validationNames.toValidDateRangeValidation
            }));

          case 20:
            return _context7.abrupt("return", Promise.resolve({
              error: false,
              messageFrom: "",
              messageTo: "",
              validationName: validationNames.datesValidRangeValidation
            }));

          case 21:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function dateRangeValidDateValidation(_x19, _x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.dateRangeValidDateValidation = dateRangeValidDateValidation;

var dateRangeBoundryValidation = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(value, props, component) {
    var _getValue8, from, to, errorMessages, fromProps, toProps, fromResult, toResult;

    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _getValue8 = getValue(props, component), from = _getValue8.from, to = _getValue8.to;
            errorMessages = props.errorMessages, fromProps = props.fromProps, toProps = props.toProps;
            fromResult = Date.parse(from);
            toResult = Date.parse(to);

            if (!(fromResult > toResult)) {
              _context8.next = 8;
              break;
            }

            return _context8.abrupt("return", Promise.reject({
              error: true,
              messageFrom: errorMessage(validationNames.dateRangeBoundry, errorMessages, "The ".concat(fromProps && fromProps.label ? fromProps.label : "From field", " must be before the ").concat(toProps && toProps.label ? toProps.label : "To field", ".")),
              validationName: validationNames.dateRangeBoundry
            }));

          case 8:
            return _context8.abrupt("return", Promise.resolve({
              error: false,
              messageFrom: "",
              messageTo: "",
              validationName: validationNames.dateRangeBoundry
            }));

          case 9:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function dateRangeBoundryValidation(_x22, _x23, _x24) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.dateRangeBoundryValidation = dateRangeBoundryValidation;

var imageMinWidthValidation = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(value, props, component) {
    var minWidth, badFiles, files, _iterator, _step, file, dim, result;

    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            minWidth = props.minWidth;
            badFiles = [];
            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator = _createForOfIteratorHelper(files);
            _context9.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context9.next = 19;
              break;
            }

            file = _step.value;

            if (!shouldValidateImagePixelDimensions(file)) {
              _context9.next = 17;
              break;
            }

            if (!file.pixelWidth) {
              _context9.next = 13;
              break;
            }

            if (file.pixelWidth < minWidth) badFiles.push("\"".concat(file.fileName, "\""));
            _context9.next = 17;
            break;

          case 13:
            _context9.next = 15;
            return getImage(file);

          case 15:
            dim = _context9.sent;

            if (dim.width < minWidth) {
              badFiles.push("\"".concat(file.fileName, "\""));
            }

          case 17:
            _context9.next = 6;
            break;

          case 19:
            _context9.next = 24;
            break;

          case 21:
            _context9.prev = 21;
            _context9.t0 = _context9["catch"](4);

            _iterator.e(_context9.t0);

          case 24:
            _context9.prev = 24;

            _iterator.f();

            return _context9.finish(24);

          case 27:
            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.imageMinWidthValidation, props.errorMessages, "Width of ".concat(badFiles.join(", "), " must be at least ").concat(minWidth, "px.")),
              validationName: validationNames.imageMinWidthValidation
            };
            return _context9.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 29:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[4, 21, 24, 27]]);
  }));

  return function imageMinWidthValidation(_x25, _x26, _x27) {
    return _ref10.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.imageMinWidthValidation = imageMinWidthValidation;

var imageMaxWidthValidation = /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(value, props, component) {
    var maxWidth, badFiles, files, _iterator2, _step2, file, dim, result;

    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            maxWidth = props.maxWidth;
            badFiles = [];
            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator2 = _createForOfIteratorHelper(files);
            _context10.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context10.next = 19;
              break;
            }

            file = _step2.value;

            if (!shouldValidateImagePixelDimensions(file)) {
              _context10.next = 17;
              break;
            }

            if (!file.pixelWidth) {
              _context10.next = 13;
              break;
            }

            if (file.pixelWidth > maxWidth) badFiles.push("\"".concat(file.fileName, "\""));
            _context10.next = 17;
            break;

          case 13:
            _context10.next = 15;
            return getImage(file);

          case 15:
            dim = _context10.sent;

            if (dim.width > maxWidth) {
              badFiles.push("\"".concat(file.fileName, "\""));
            }

          case 17:
            _context10.next = 6;
            break;

          case 19:
            _context10.next = 24;
            break;

          case 21:
            _context10.prev = 21;
            _context10.t0 = _context10["catch"](4);

            _iterator2.e(_context10.t0);

          case 24:
            _context10.prev = 24;

            _iterator2.f();

            return _context10.finish(24);

          case 27:
            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.imageMaxWidthValidation, props.errorMessages, "Width of ".concat(badFiles.join(", "), " must be no more than ").concat(maxWidth, "px.")),
              validationName: validationNames.imageMaxWidthValidation
            };
            return _context10.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 29:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[4, 21, 24, 27]]);
  }));

  return function imageMaxWidthValidation(_x28, _x29, _x30) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.imageMaxWidthValidation = imageMaxWidthValidation;

var imageMinHeightValidation = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(value, props, component) {
    var minHeight, badFiles, files, _iterator3, _step3, file, dim, result;

    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            minHeight = props.minHeight;
            badFiles = [];
            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator3 = _createForOfIteratorHelper(files);
            _context11.prev = 4;

            _iterator3.s();

          case 6:
            if ((_step3 = _iterator3.n()).done) {
              _context11.next = 19;
              break;
            }

            file = _step3.value;

            if (!shouldValidateImagePixelDimensions(file)) {
              _context11.next = 17;
              break;
            }

            if (!file.pixelHeight) {
              _context11.next = 13;
              break;
            }

            if (file.pixelHeight < minHeight) badFiles.push("\"".concat(file.fileName, "\""));
            _context11.next = 17;
            break;

          case 13:
            _context11.next = 15;
            return getImage(file);

          case 15:
            dim = _context11.sent;

            if (dim.height < minHeight) {
              badFiles.push("\"".concat(file.fileName, "\""));
            }

          case 17:
            _context11.next = 6;
            break;

          case 19:
            _context11.next = 24;
            break;

          case 21:
            _context11.prev = 21;
            _context11.t0 = _context11["catch"](4);

            _iterator3.e(_context11.t0);

          case 24:
            _context11.prev = 24;

            _iterator3.f();

            return _context11.finish(24);

          case 27:
            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.imageMinHeightValidation, props.errorMessages, "Height of ".concat(badFiles.toString().replace(/,/g, ", "), " must be at least ").concat(minHeight, "px.")),
              validationName: validationNames.imageMinHeightValidation
            };
            return _context11.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 29:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[4, 21, 24, 27]]);
  }));

  return function imageMinHeightValidation(_x31, _x32, _x33) {
    return _ref12.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.imageMinHeightValidation = imageMinHeightValidation;

var imageMaxHeightValidation = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(value, props, component) {
    var maxHeight, badFiles, files, _iterator4, _step4, file, dim, result;

    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            maxHeight = props.maxHeight;
            badFiles = [];
            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator4 = _createForOfIteratorHelper(files);
            _context12.prev = 4;

            _iterator4.s();

          case 6:
            if ((_step4 = _iterator4.n()).done) {
              _context12.next = 19;
              break;
            }

            file = _step4.value;

            if (!shouldValidateImagePixelDimensions(file)) {
              _context12.next = 17;
              break;
            }

            if (!file.pixelHeight) {
              _context12.next = 13;
              break;
            }

            if (file.pixelHeight > maxHeight) badFiles.push("\"".concat(file.fileName, "\""));
            _context12.next = 17;
            break;

          case 13:
            _context12.next = 15;
            return getImage(file);

          case 15:
            dim = _context12.sent;

            if (dim.height > maxHeight) {
              badFiles.push("\"".concat(file.fileName, "\""));
            }

          case 17:
            _context12.next = 6;
            break;

          case 19:
            _context12.next = 24;
            break;

          case 21:
            _context12.prev = 21;
            _context12.t0 = _context12["catch"](4);

            _iterator4.e(_context12.t0);

          case 24:
            _context12.prev = 24;

            _iterator4.f();

            return _context12.finish(24);

          case 27:
            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.imageMaxHeightValidation, props.errorMessages, "Height of ".concat(badFiles.toString().replace(/,/g, ", "), " must be no more than ").concat(maxHeight, "px.")),
              validationName: validationNames.imageMaxHeightValidation
            };
            return _context12.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 29:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[4, 21, 24, 27]]);
  }));

  return function imageMaxHeightValidation(_x34, _x35, _x36) {
    return _ref13.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.imageMaxHeightValidation = imageMaxHeightValidation;

var imageAspectRatioValidation = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(value, props, component) {
    var aspectRatio, badFiles, gcd, files, _iterator5, _step5, file, div, ratioWidth, ratioHeight, dim, _div, _ratioWidth, _ratioHeight, result;

    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            aspectRatio = props.aspectRatio;
            badFiles = [];

            gcd = function gcd(a, b) {
              if (!b) {
                return a;
              }

              return gcd(b, a % b);
            };

            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator5 = _createForOfIteratorHelper(files);
            _context13.prev = 5;

            _iterator5.s();

          case 7:
            if ((_step5 = _iterator5.n()).done) {
              _context13.next = 26;
              break;
            }

            file = _step5.value;

            if (!shouldValidateImagePixelDimensions(file)) {
              _context13.next = 24;
              break;
            }

            if (!(file.pixelHeight && file.pixelWidth)) {
              _context13.next = 17;
              break;
            }

            div = gcd(file.pixelWidth, file.pixelHeight);
            ratioWidth = file.pixelWidth / div;
            ratioHeight = file.pixelHeight / div;

            if (aspectRatio.width !== ratioWidth || aspectRatio.height !== ratioHeight) {
              badFiles.push("\"".concat(file.fileName, "\""));
            }

            _context13.next = 24;
            break;

          case 17:
            _context13.next = 19;
            return getImage(file);

          case 19:
            dim = _context13.sent;
            _div = gcd(dim.width, dim.height);
            _ratioWidth = dim.width / _div;
            _ratioHeight = dim.height / _div;

            if (aspectRatio.width !== _ratioWidth || aspectRatio.height !== _ratioHeight) {
              badFiles.push("\"".concat(file.fileName, "\""));
            }

          case 24:
            _context13.next = 7;
            break;

          case 26:
            _context13.next = 31;
            break;

          case 28:
            _context13.prev = 28;
            _context13.t0 = _context13["catch"](5);

            _iterator5.e(_context13.t0);

          case 31:
            _context13.prev = 31;

            _iterator5.f();

            return _context13.finish(31);

          case 34:
            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.imageAspectRatioValidation, props.errorMessages, "Aspect ratio of ".concat(badFiles.toString().replace(/,/g, ", "), " is not a ").concat(aspectRatio.width, ":").concat(aspectRatio.height, " image.")),
              validationName: validationNames.imageMaxHeightValidation
            };
            return _context13.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 36:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[5, 28, 31, 34]]);
  }));

  return function imageAspectRatioValidation(_x37, _x38, _x39) {
    return _ref14.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.imageAspectRatioValidation = imageAspectRatioValidation;

var mustBeImageValidation = /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(value, props, component) {
    var mustBeImage, badFiles, files, _iterator6, _step6, file, result;

    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            mustBeImage = props.mustBeImage;
            badFiles = [];

            if (mustBeImage) {
              files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
              _iterator6 = _createForOfIteratorHelper(files);

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  file = _step6.value;
                  if (!file.isImage) badFiles.push("\"".concat(file.fileName, "\""));
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }

            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.mustBeImageValidation, props.errorMessages, "".concat(badFiles.join(", "), " ").concat(badFiles.length > 1 ? "must be images." : "must be an image.")),
              validationName: validationNames.mustBeImageValidation
            };
            return _context14.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function mustBeImageValidation(_x40, _x41, _x42) {
    return _ref15.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.mustBeImageValidation = mustBeImageValidation;

var minSizeValidation = /*#__PURE__*/function () {
  var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(value, props, component) {
    var minSize, badFiles, files, _iterator7, _step7, file, result;

    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            minSize = props.minSize;
            badFiles = [];
            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator7 = _createForOfIteratorHelper(files);

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                file = _step7.value;

                if (minSize && file.fileSize < props.minSize) {
                  badFiles.push("\"".concat(file.fileName, "\""));
                }
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }

            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.minSizeValidation, props.errorMessages, "".concat(badFiles.join(", "), " ").concat(badFiles.length > 1 ? "are" : "is", " less than the minimum size of ").concat(Math.round(props.minSize * 100.0 / 1000) / 100, "KB.")),
              validationName: validationNames.minSizeValidation
            };
            return _context15.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 7:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function minSizeValidation(_x43, _x44, _x45) {
    return _ref16.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.minSizeValidation = minSizeValidation;

var maxSizeValidation = /*#__PURE__*/function () {
  var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(value, props, component) {
    var maxSize, badFiles, files, _iterator8, _step8, file, result;

    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            maxSize = props.maxSize;
            badFiles = [];
            files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
            _iterator8 = _createForOfIteratorHelper(files);

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                file = _step8.value;

                if (maxSize && file.fileSize > props.maxSize) {
                  badFiles.push("\"".concat(file.fileName, "\""));
                }
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }

            result = {
              error: badFiles.length > 0,
              message: errorMessage(validationNames.maxSizeValidation, props.errorMessages, "".concat(badFiles.join(", "), " ").concat(badFiles.length > 1 ? "are" : "is", " greater than the maximum size of ").concat(Math.round(props.maxSize * 100.0 / 1000) / 100, "KB.")),
              validationName: validationNames.maxSizeValidation
            };
            return _context16.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 7:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function maxSizeValidation(_x46, _x47, _x48) {
    return _ref17.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.maxSizeValidation = maxSizeValidation;

var rejectedFilesValidation = /*#__PURE__*/function () {
  var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(value, props, component) {
    var defaultMessages, index, file, fileExt, result;
    return _regenerator.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            defaultMessages = [];

            if (Array.isArray(props.filesRejected)) {
              for (index in props.filesRejected) {
                file = props.filesRejected[index];

                if (props.maxSize && file.size > props.maxSize) {
                  defaultMessages.push("".concat(file.name, " is greater than the maximum size of ").concat(Math.round(props.maxSize / 1000), "KB"));
                }

                if (props.minSize && file.size < props.minSize) {
                  defaultMessages.push("".concat(file.name, " is less than the minimum size of ").concat(Math.round(props.minSize / 1000), "KB"));
                }

                fileExt = "." + file.name.split(".").pop();

                if (props.fileTypes && !props.fileTypes.includes(fileExt)) {
                  defaultMessages.push("".concat(file.name, " does not match the expected file extensions of ").concat(props.fileTypes));
                }

                if (props.mustBeImage && !file.type.includes("image")) {
                  defaultMessages.push("".concat(file.name, " is not an image file."));
                }
              }
            }

            result = {
              error: Array.isArray(props.filesRejected) && props.filesRejected.length > 0,
              message: errorMessage(validationNames.rejectedFilesValidation, props.errorMessages, defaultMessages.join("  |  ")),
              validationName: validationNames.imageMaxHeightValidation
            };
            return _context17.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 4:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function rejectedFilesValidation(_x49, _x50, _x51) {
    return _ref18.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.rejectedFilesValidation = rejectedFilesValidation;

var referenceMaxItems = /*#__PURE__*/function () {
  var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(value, props, component) {
    var result;
    return _regenerator.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            result = {
              error: value && value.length > component.props.maxItems,
              message: "Records exceeded maximum allowed of (".concat(component.props.maxItems, ")"),
              validationName: validationNames.referenceMaxItems
            };
            return _context18.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 2:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function referenceMaxItems(_x52, _x53, _x54) {
    return _ref19.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.referenceMaxItems = referenceMaxItems;

var referenceMinItems = /*#__PURE__*/function () {
  var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(value, props, component) {
    var result;
    return _regenerator.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            result = {
              error: value && value.length < component.props.minItems,
              message: "Records are less than the minimum requirement of (".concat(component.props.minItems, ")."),
              validationName: validationNames.referenceMinItems
            };
            return _context19.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 2:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function referenceMinItems(_x55, _x56, _x57) {
    return _ref20.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.referenceMinItems = referenceMinItems;

var allowedExtensionsValidation = /*#__PURE__*/function () {
  var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(value, props, component) {
    var fileTypes, badFiles, files, _iterator9, _step9, file, result;

    return _regenerator.default.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            fileTypes = props.fileTypes;
            badFiles = [];

            if (fileTypes) {
              files = component && typeof component.getSelectedAssets == "function" ? component.getSelectedAssets() : value;
              _iterator9 = _createForOfIteratorHelper(files);

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  file = _step9.value;
                  if (!fileTypes.includes(file.fileExtension)) badFiles.push("\"".concat(file.fileName, "\""));
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }

            result = {
              error: badFiles.length > 0,
              message: "Only the following files types are allowed: ".concat(props.fileTypes),
              validationName: validationNames.allowedExtensionsValidation
            };
            return _context20.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 5:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function allowedExtensionsValidation(_x58, _x59, _x60) {
    return _ref21.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.allowedExtensionsValidation = allowedExtensionsValidation;

var geoLocationRequireValidation = function geoLocationRequireValidation(value, props, component) {
  var message = [];
  var hasError = false;

  if (props.fields.showAddress1 && !value.address1) {
    message.push("Street Address");
  }

  if (props.fields.showCity && !value.city) {
    message.push("City");
  }

  if (props.fields.showState && !value.state) {
    message.push("State");
  }

  if (props.fields.showZipCode && !value.zip) {
    message.push("ZIP code");
  }

  var formattedErrorMessage = message.join(", ");

  if (message.length > 1) {
    var replacement = " and";
    formattedErrorMessage = formattedErrorMessage.replace(/,([^,]*)$/, replacement + "$1");
  }

  hasError = !value || message.length > 0;
  var result = {
    error: hasError,
    message: hasError ? errorMessage(validationNames.required, props.errorMessages, "".concat(formattedErrorMessage, " is required.")) : "",
    validationName: validationNames.required
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.geoLocationRequireValidation = geoLocationRequireValidation;

var childComponentValidation = /*#__PURE__*/function () {
  var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(value, props, component) {
    var componentResult, results, hasError, _iterator10, _step10, childComponent, result;

    return _regenerator.default.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            /**
             * Component utilizing this validator needs to have an array of referenced components
             * that are of type `enhanceWithValidation`. This will give us the ability to iterate
             * through those components and call the `enhanceWithValidation.validate()` function.
             *
             * If there is an error in any of the child components, we will then return the array,
             * otherwise we return false.
             */
            results = [];
            hasError = false;

            if (!(component.childComponents && component.childComponents.length > 0)) {
              _context21.next = 24;
              break;
            }

            _iterator10 = _createForOfIteratorHelper(component.childComponents);
            _context21.prev = 4;

            _iterator10.s();

          case 6:
            if ((_step10 = _iterator10.n()).done) {
              _context21.next = 16;
              break;
            }

            childComponent = _step10.value;

            if (!(childComponent.current && childComponent.current.validate)) {
              _context21.next = 14;
              break;
            }

            _context21.next = 11;
            return childComponent.current.validate();

          case 11:
            componentResult = _context21.sent;
            hasError = hasError || componentResult.error;
            results.push(componentResult);

          case 14:
            _context21.next = 6;
            break;

          case 16:
            _context21.next = 21;
            break;

          case 18:
            _context21.prev = 18;
            _context21.t0 = _context21["catch"](4);

            _iterator10.e(_context21.t0);

          case 21:
            _context21.prev = 21;

            _iterator10.f();

            return _context21.finish(21);

          case 24:
            result = {
              error: hasError ? results : false,
              message: "",
              validationName: validationNames.childComponentValidation
            };
            return _context21.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 26:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[4, 18, 21, 24]]);
  }));

  return function childComponentValidation(_x61, _x62, _x63) {
    return _ref22.apply(this, arguments);
  };
}();

exports.childComponentValidation = childComponentValidation;

var getValue = function getValue(value, component) {
  var _ref23, _value$value;

  return (_ref23 = (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : value) !== null && _ref23 !== void 0 ? _ref23 : component.props.value;
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


var recurrenceValidation = function recurrenceValidation(value, props, component) {
  var _getValue9;

  var error = !props.allowRecurring && !value;
  var message = "These fields cannot be blank.";
  var recurrence = (_getValue9 = getValue(value, component)) === null || _getValue9 === void 0 ? void 0 : _getValue9.recurrence; // If recurrence is being used, check its fields

  if (recurrence && recurrence.type !== _recurrenceTypes.recurrenceTypes.NONE) {
    // falsy check for occurrrences is ok because its a string value
    if (!recurrence.until && !recurrence.occurrences) {
      error = true;
    }

    if (!error && !recurrence.until && recurrence.occurrences && recurrence.occurrences < 1) {
      error = true;
      message = "The number of occurrences must be greater than 0.";
    } // The interval must be above 1, anything below that doesn't make sense.


    if (!recurrence.interval) {
      error = true;
    }

    if (!error && recurrence.interval < 1) {
      error = true;
      message = "The interval must be greater than 0.";
    } // WEEKLY


    if (recurrence.type === _recurrenceTypes.recurrenceTypes.WEEKLY) {
      // Weekdays must be selected.
      if (!recurrence.weekdays || recurrence.weekdays.length === 0) {
        error = true;
        message = "Weekdays must be selected.";
      }
    } //MONTHLY


    if (recurrence.type === _recurrenceTypes.recurrenceTypes.MONTHLY) {
      // if offset is empty, this means the toggle is set to repeatOn so there should be a dayOfMonth.
      if (!recurrence.dayOfMonth && !recurrence.offset || recurrence.dayOfMonth && recurrence.dayOfMonth < 1 || recurrence.dayOfMonth > 31) {
        error = true;
        message = '"Each" field must be a valid day of the month.';
      }
    }
  }

  var result = {
    error: error,
    message: errorMessage(validationNames.required, props.errorMessages, message),
    validationName: validationNames.required
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.recurrenceValidation = recurrenceValidation;

var linkFieldValidation = function linkFieldValidation(value, props, component) {
  var result = {
    error: props.required && !value.url,
    message: errorMessage(validationNames.required, props.errorMessages, "This field cannot be blank."),
    validationName: validationNames.required
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.linkFieldValidation = linkFieldValidation;

var wrappedFieldRendererValidation = /*#__PURE__*/function () {
  var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(value, props, component) {
    var isValid, result;
    return _regenerator.default.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return component.handleValidation();

          case 2:
            isValid = _context22.sent;
            result = {
              error: !isValid,
              message: "",
              validationName: validationNames.wrappedFieldRendererValidation
            };
            return _context22.abrupt("return", result.error ? Promise.reject(result) : Promise.resolve(result));

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function wrappedFieldRendererValidation(_x64, _x65, _x66) {
    return _ref24.apply(this, arguments);
  };
}();
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.wrappedFieldRendererValidation = wrappedFieldRendererValidation;

var specialCharactersValidation = function specialCharactersValidation(value, props, component) {
  var result = {
    error: (0, _StringHelper.hasSpecialCharacters)(value),
    message: errorMessage(validationNames.required, props.errorMessages, "This field cannot include special characters."),
    validationName: validationNames.specialCharactersValidation
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};
/**
 * @param value any
 * @param props ValidationProps
 * @param component any
 *
 * @returns Promise<ValidationResult>
 */


exports.specialCharactersValidation = specialCharactersValidation;

var emailValidation = function emailValidation(value, props, component) {
  var result = {
    error: !(0, _StringHelper.isValidEmail)(value),
    message: errorMessage(validationNames.required, props.errorMessages, "This field must be a valid Email Address."),
    validationName: validationNames.emailValidation
  };
  return result.error ? Promise.reject(result) : Promise.resolve(result);
};

exports.emailValidation = emailValidation;

function enhanceWithValidation(WrappedComponent) {
  var _class, _temp;

  // Don't want to use ValidationComponentProps here just yet, so using any for now.
  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2.default)(ValidationComponent, _React$Component);

    var _super = _createSuper(ValidationComponent);

    function ValidationComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, ValidationComponent);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrappedComponentRef", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlur", function (e) {
        if (_this.props.onlyValidateOnBlur && !_this.props.doNotValidate) {
          _this.validate();
        }

        _this.props.onBlur && _this.props.onBlur(e);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validate", /*#__PURE__*/function () {
        var _ref25 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(value) {
          var _value;

          var _this$props, validations, others, messages, messagesFrom, messagesTo, validationNames, _iterator11, _step11, validation, result;

          return _regenerator.default.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  // doNotValidate prop does not go here, but in the functions consuming it.
                  // This way, the validate function can be called directly within the component, and still work.
                  _this$props = _this.props, validations = _this$props.validations, others = (0, _objectWithoutProperties2.default)(_this$props, ["validations"]);
                  value = (_value = value) !== null && _value !== void 0 ? _value : _this.props.value;
                  messages = [];
                  messagesFrom = [];
                  messagesTo = [];
                  validationNames = [];
                  _iterator11 = _createForOfIteratorHelper(validations ? validations : []);
                  _context23.prev = 7;

                  _iterator11.s();

                case 9:
                  if ((_step11 = _iterator11.n()).done) {
                    _context23.next = 24;
                    break;
                  }

                  validation = _step11.value;
                  _context23.prev = 11;
                  _context23.next = 14;
                  return validation(value, _objectSpread({}, others), _this.wrappedComponentRef.current);

                case 14:
                  _context23.next = 22;
                  break;

                case 16:
                  _context23.prev = 16;
                  _context23.t0 = _context23["catch"](11);
                  if (_context23.t0.messageFrom) messagesFrom.push(_context23.t0.messageFrom);
                  if (_context23.t0.messageTo) messagesTo.push(_context23.t0.messageTo);
                  if (_context23.t0.message) messages.push(_context23.t0.message);
                  validationNames.push(_context23.t0.validationName);

                case 22:
                  _context23.next = 9;
                  break;

                case 24:
                  _context23.next = 29;
                  break;

                case 26:
                  _context23.prev = 26;
                  _context23.t1 = _context23["catch"](7);

                  _iterator11.e(_context23.t1);

                case 29:
                  _context23.prev = 29;

                  _iterator11.f();

                  return _context23.finish(29);

                case 32:
                  if (messagesFrom.length == 0 && messagesTo.length == 0) {
                    result = messages.length > 0 ? {
                      error: true,
                      message: messages.join(" "),
                      validationName: validationNames.join(", ")
                    } : {
                      error: false,
                      message: "",
                      validationName: null
                    };
                  } else {
                    result = {
                      error: {
                        from: false,
                        to: false
                      },
                      message: {
                        from: messagesFrom.join(" "),
                        to: messagesTo.join(" ")
                      },
                      validationName: validationNames.join(", ")
                    };

                    if (result.message) {
                      if (messages.length > 0) {
                        result.message["from"] += " " + messages.join(" ");
                        result.message["to"] += " " + messages.join(" ");
                      }

                      if (result.message["from"].length > 0) result.error["from"] = true;
                      if (result.message["to"].length > 0) result.error["to"] = true;
                    }
                  }

                  _this.setState(result);

                  if (typeof _this.props.onValidation === "function") {
                    _this.props.onValidation(result);
                  }

                  return _context23.abrupt("return", result);

                case 36:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23, null, [[7, 26, 29, 32], [11, 16]]);
        }));

        return function (_x67) {
          return _ref25.apply(this, arguments);
        };
      }());
      _this.state = {
        error: false,
        message: "",
        validationName: ""
      };
      _this.wrappedComponentRef = /*#__PURE__*/_react.default.createRef();
      return _this;
    }

    (0, _createClass2.default)(ValidationComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var haveValue = this.props.value || this.props.zeroIsValidValue && this.props.value === 0;

        if (haveValue && !this.props.doNotValidate && !this.props.onlyValidateOnBlur) {
          this.validate();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (this.props.onlyValidateOnBlur || this.props.doNotValidate) {
          return;
        }

        if (!(0, _fastDeepEqual.default)(this.props.value, prevProps.value)) {
          this.validate();
        } else if (this.props.filesRejected && !(0, _fastDeepEqual.default)(this.props.filesRejected, prevProps.filesRejected)) {
          this.validate();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
          ref: this.wrappedComponentRef,
          innerRef: function innerRef(ref) {
            _this2.wrappedComponentRef = {
              current: ref
            };
          }
        }, this.props, {
          onBlur: this.onBlur,
          executeValidation: this.validate,
          error: this.state.error || this.props.error,
          errorMessage: this.state.message,
          validationName: this.state.validationName
        }));
      }
    }]);
    return ValidationComponent;
  }(_react.default.Component), (0, _defineProperty2.default)(_class, "propTypes", _Validations.default), (0, _defineProperty2.default)(_class, "defaultProps", {
    error: false
  }), _temp;
}

var _default = enhanceWithValidation;
exports.default = _default;